(() => {
  if (window.Shopify?.designMode || window.vynseraGiftsLoaded) return;
  window.vynseraGiftsLoaded = true;
  const config = JSON.parse(document.getElementById('vynsera-gift-config').textContent);
  const baseFetch = window.fetch.bind(window);
  const root = window.Shopify?.routes?.root || '/';
  let queue = Promise.resolve();
  let timer;
  const request = async (route, data) => {
    const response = await baseFetch(root + route, data ? {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(data)} : {});
    if (!response.ok) throw new Error('Gift cart update failed');
    return response.json();
  };
  const plan = (cart) => {
    const paid = cart.items.filter(item => !item.properties?._vynsera_gift && item.variant_id !== config.book);
    const hasPaid = paid.some(item => item.original_line_price > 0);
    return {book:hasPaid};
  };
  const synchronize = async () => {
    let cart = await request('cart.js');
    const target = plan(cart);
    const additions=[];
    let changed=false;
    for (const gift of ['book']) {
      const id=config[gift];
      const existing=cart.items.filter(item => item.properties?._vynsera_gift === gift || (gift==='book' && item.variant_id===id));
      const updates={};
      existing.forEach((item,index) => {
        const quantity=target[gift] && index===0 ? 1 : 0;
        if(item.quantity!==quantity)updates[item.key]=quantity;
      });
      if(Object.keys(updates).length){cart=await request('cart/update.js',{updates});changed=true;}
      if(target[gift] && !existing.length)additions.push({id,quantity:1,properties:{_vynsera_gift:gift,Offer:config.bookOffer}});
    }
    if(additions.length){await request('cart/add.js',{items:additions});changed=true;}
    cart=await request('cart.js');
    if(changed && document.querySelector('cart-items') && !document.querySelector('cart-drawer')){
      window.location.reload();
      return;
    }
    if(changed && typeof window.publish==='function' && typeof PUB_SUB_EVENTS!=='undefined') {
      window.publish(PUB_SUB_EVENTS.cartUpdate,{source:'vynsera-gifts'});
    }
    if(changed){
      const result=await request('?sections=cart-drawer,cart-icon-bubble,main-cart-items,main-cart-footer');
      const parsed=new DOMParser();
      if(result['cart-drawer']){
        const fresh=parsed.parseFromString(result['cart-drawer'],'text/html');
        const current=document.getElementById('CartDrawer');
        const next=fresh.getElementById('CartDrawer');
        if(current && next)current.innerHTML=next.innerHTML;
        document.querySelector('cart-drawer')?.classList.toggle('is-empty',!target.book);
      }
      for (const section of ['main-cart-items','main-cart-footer']) {
        if(!result[section])continue;
        const fresh=parsed.parseFromString(result[section],'text/html');
        const next=fresh.querySelector('.shopify-section');
        const current=next && document.getElementById(next.id);
        if(current)current.innerHTML=next.innerHTML;
      }
      if(result['cart-icon-bubble']){
        const fresh=parsed.parseFromString(result['cart-icon-bubble'],'text/html');
        const current=document.getElementById('cart-icon-bubble');
        const next=fresh.querySelector('.shopify-section');
        if(current && next)current.innerHTML=next.innerHTML;
      }
    }
  };
  const run=()=>{queue=queue.catch(()=>{}).then(synchronize);return queue};
  const schedule=()=>{clearTimeout(timer);timer=setTimeout(()=>run().catch(()=>{}),250)};
  window.fetch=async(...args)=>{
    const response=await baseFetch(...args);
    const url=typeof args[0]==='string'?args[0]:args[0]?.url;
    if(response.ok && /\/cart\/(add|change|update|clear)(\.js)?(?:\?|$)/.test(url || ''))schedule();
    if(response.ok && /\/cart\/add(\.js)?(?:\?|$)/.test(url || '') && !window.location.pathname.replace(/\/$/,'').endsWith('/cart')){
      response.clone().json().then(data=>{if(!data.status)window.location.assign(root+'cart')}).catch(()=>{});
    }
    return response;
  };
  if(typeof window.subscribe==='function' && typeof PUB_SUB_EVENTS!=='undefined'){
    window.subscribe(PUB_SUB_EVENTS.cartUpdate,event=>{if(event.source!=='vynsera-gifts')schedule()});
  }
  document.addEventListener('click',async(event)=>{
    const checkout=event.target.closest('[name="checkout"],a[href="/checkout"],a[href$="/checkout"]');
    if(!checkout || event.defaultPrevented)return;
    event.preventDefault();
    event.stopImmediatePropagation();
    checkout.setAttribute('aria-busy','true');
    try{await run();window.location.assign(root+'checkout')}
    catch(error){checkout.removeAttribute('aria-busy');window.location.assign(root+'cart')}
  },true);
  schedule();
})();